"use client";

import { c as _c } from "react/compiler-runtime";
import FAQSection from "@components/foundations/faq-section/FAQSection";
import { POOLS_FAQ_DESCRIPTION, POOLS_FAQS } from "@consts/faqs";
import { LiquidityPools } from "@pools/components";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { useEffect } from "react";
import { PAGE_MASTHEAD_TITLE_CLASS } from "@/consts/typography";
import { capturePosthogEvent } from "@/lib/posthog-browser";
import { useAuth } from "@/providers/auth";
import { cx } from "@/utils/cx";
export default function PoolsPageClient() {
  const $ = _c(7);
  const {
    isLoggedIn,
    user
  } = useAuth();
  let t0;
  if ($[0] !== isLoggedIn || $[1] !== user?.membership?.planId) {
    t0 = () => {
      capturePosthogEvent("page_viewed", {
        page_name: "pools",
        is_logged_in: isLoggedIn,
        user_plan: user?.membership?.planId || null
      });
    };
    $[0] = isLoggedIn;
    $[1] = user?.membership?.planId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = user?.membership?.planId;
  let t2;
  if ($[3] !== isLoggedIn || $[4] !== t1) {
    t2 = [isLoggedIn, t1];
    $[3] = isLoggedIn;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t0, t2);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NuqsAdapter><div><h1 className={cx(PAGE_MASTHEAD_TITLE_CLASS, "mb-4 text-center md:mb-6")}>Explore Pools</h1><LiquidityPools /><FAQSection faqs={POOLS_FAQS} description={POOLS_FAQ_DESCRIPTION} /></div></NuqsAdapter>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}